import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ruta } from 'src/app/pago/enums/Ruta.enum';
import {
  DynatraceService,
  PushDatalayersGoogleTagManager,
  TenantService,
} from '@segurosvoluntarios_vel/commons-services';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { Subscription } from 'rxjs';
import {
  changeMedioDePago,
  clearError,
  errorEnPago,
  idPagoInvalidFromUrl,
  loadConfiguracionDePago,
  registerOtroMedioDePago,
  saveProductNameFromUrl,
} from 'src/app/store/actions/pago.action';
import { MedioDePago } from 'src/app/pago/enums/MedioDePago.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { MensajeError } from 'src/app/pago/enums/MensajeError.enum';
import { ButtonTextModal } from 'src/app/pago/enums/ButtonTextModal.enum';
import { getContenido } from 'src/app/store/actions/content.action';
import { Pago } from 'src/app/pago/models/Pago.model';
import { PagoFacade } from 'src/app/pago/services/pago-facade/pago.facade';
import { PagoBuilder } from 'src/app/pago/builders/pago/pago.builder';
import { TagPrismicPorProducto } from 'src/app/pago/enums/TagPrismicPorProducto.enum';
import { DatalayerEvent } from 'src/app/pago/models/DatalayerEvent.model';
import { take } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { IdProducto } from 'src/app/pago/enums/IdProducto.enum';
import { NombreProducto } from 'src/app/pago/const/NombreProducto.const';
import { ERROR_IDPAGO_INVALIDO } from 'src/app/pago/const/IdPagoInvalido.const';
import { CARACTERES_ESPECIALES_REGEX } from 'src/app/pago/const/RegEx.const';
import { SESSION_STORE } from '../../enums/SessionStore.enum';
import { getDatoDeConfiguracionPago } from 'src/app/shared/utils/metada.utils';
import { ResumenDescuentosFacade } from 'src/app/pago/services/resumen-descuentos/resumen-descuentos-facade.service';
import { ContenidoFacade } from 'src/app/pago/services/content-facade/content-facade.service';
import { DatalayerRegisterPagoService } from 'src/app/pago/services/dalayer-register/datalayer-register-pago.service';
import { PagoService } from 'src/app/pago/services/pago/pago.service';

@Component({
  selector: 'app-datos',
  templateUrl: './datos.component.html',
  styleUrls: ['./datos.component.scss'],
})
export class DatosComponent implements OnInit, OnDestroy {
  static readonly ACTION_TIMER_DONE = 'done';
  @ViewChild('modalGoBack') modalGoBack: TemplateRef<any>;
  subscription: Subscription = new Subscription();
  configuracionDePago: ConfiguracionDePago;
  pago: Pago;
  medioDePagoTDC = MedioDePago.TARJETA_DE_CREDITO;
  medioDePagoPSE = MedioDePago.OTRO_MEDIO_DE_PAGO;
  tenant: string;
  tiempoLimiteExpiracionPago: number;
  idPago: string;
  submitted: boolean;
  formularioMedioDePago: FormControl;
  productName: string;
  isProductoSoat: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    public pagoFacade: PagoFacade,
    public resumenDescuentosFacade: ResumenDescuentosFacade,
    public contenidoFacade: ContenidoFacade,
    private tenantService: TenantService,
    public ngbModal: NgbModal,
    private location: Location,
    private datalayerRegisterPagoService: DatalayerRegisterPagoService,
    private pagoService: PagoService,
    private dynatraceService: DynatraceService
  ) {
    this.getIdProductoFromUrl();
    this.getIdPagoFromUrl();
    this.tenantService.getTenant().subscribe(tenant => {
      this.tenant = tenant;
    });
  }

  ngOnInit(): void {
    this.loadConfiguracionDePago();
    this.subscribeToConfiguracionDePago();
    this.subscribeToPago();
    this.subscribeToUrlRedirectOtroMedioDePago();
    this.crearFormularioMedioDePago();
  }

  crearFormularioMedioDePago(): void {
    this.formularioMedioDePago = new FormControl(null, [Validators.required]);
  }

  saveProductNameFromUrl(productName: string): void {
    this.pagoFacade.dispatch(
      saveProductNameFromUrl({
        productName,
      })
    );
  }

  loadConfiguracionDePago(): void {
    if (!this.idPago) return;

    this.pagoFacade.dispatch(
      loadConfiguracionDePago({
        idPago: this.idPago,
      })
    );
  }

  getIdPagoFromUrl() {
    this.activatedRoute.params.pipe(take(1)).subscribe(params => {
      this.validateIdPago(params[Ruta.ID_PAGO]);
    });
  }

  getIdProductoFromUrl() {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe(params => {
      if (!params[Ruta.PRODUCTO]) {
        this.saveProductNameFromUrl(IdProducto.PRODUCTO_UNKNOWN);
        return;
      }
      this.productName = params[Ruta.PRODUCTO];
      const productNameId =
        NombreProducto[this.productName] || IdProducto.PRODUCTO_UNKNOWN;
      this.pagoService.productName = productNameId;
      this.saveProductNameFromUrl(productNameId);
    });
  }

  subscribeToConfiguracionDePago() {
    this.pagoFacade.configuracionDePago$.subscribe(
      (configuracionDePago: ConfiguracionDePago) => {
        this.configuracionDePago = configuracionDePago;
        if (
          configuracionDePago.idProducto === IdProducto.PRODUCTO_SOAT ||
          configuracionDePago.idProducto ===
            IdProducto.PRODUCTO_SOAT_FLUJO_VENTA
        ) {
          this.isProductoSoat = true;
        }
        this.setExpiracionPago(
          new Date(configuracionDePago.tiempoLimiteTransaccion)
        );
        this.contenidoFacade.dispatch(
          getContenido({
            tenant: this.tenant.toLocaleLowerCase(),
            producto: TagPrismicPorProducto[configuracionDePago.idProducto],
          })
        );
      }
    );
  }

  subscribeToPago() {
    this.subscription.add(
      this.pagoFacade.pago$.subscribe((pago: Pago) => (this.pago = pago))
    );
  }

  subscribeToUrlRedirectOtroMedioDePago() {
    this.pagoFacade.urlRedirectOtroMedioDePago$.subscribe(
      (urlRedirectOtroMedioDePago: string) => {
        window.location.replace(urlRedirectOtroMedioDePago);
      }
    );
  }

  setExpiracionPago(tiempoLimiteTransaccion: Date) {
    /* Esta lógica es temporal mientras se soluciona bug en back
     ya que no se valida en ciertos casos que el tiempo expiro y
     responde un 200 el servicio. */
    const betweenTime = Math.floor(
      (new Date().getTime() - new Date(tiempoLimiteTransaccion).getTime()) /
        1000
    );
    if (betweenTime < 0) {
      this.tiempoLimiteExpiracionPago = Math.abs(betweenTime);
    } else {
      this.handleEventCountDown(DatosComponent.ACTION_TIMER_DONE);
    }
  }

  handleEventCountDown(action: string) {
    if (action === DatosComponent.ACTION_TIMER_DONE) {
      this.pagoFacade.dispatch(
        errorEnPago({
          error: {
            active: true,
            description: MensajeError.TIEMPO_LIMITE_TRANSACCION,
            buttonText: ButtonTextModal.REGRESAR,
            buttonAction: this.configuracionDePago.urlRetorno,
          },
        })
      );
    }
  }

  clearErrorModal() {
    this.pagoFacade.dispatch(clearError());
  }

  goBackProducto() {
    this.pago.idProducto !== IdProducto.PRODUCTO_SOAT
      ? this.ngbModal.open(this.modalGoBack, {
          centered: true,
        })
      : this.goBack();
  }

  goBack() {
    if (this.configuracionDePago.urlRetorno) {
      window.location.href = this.configuracionDePago.urlRetorno;
    } else {
      this.location.back();
    }
    this.ngbModal.dismissAll();
  }

  handlePagarOtroMedio() {
    this.submitted = true;
    if (this.formularioMedioDePago.valid) {
      this.handlePushDatalayer(
        this.datalayerRegisterPagoService.build(
          this.pago,
          this.configuracionDePago,
          MedioDePago.OTRO_MEDIO_DE_PAGO
        )
      );
      this.dynatraceService.enterAction(
        `${MedioDePago.MEDIO_PAGO_SELECCIONADO}: ${this.formularioMedioDePago.value}`
      );

      this.pagoFacade.dispatch(
        registerOtroMedioDePago({ pago: this.buildPago() })
      );

      const prepoliza = getDatoDeConfiguracionPago(
        this.configuracionDePago,
        DatalayerRegisterPagoService.PREPOLIZA
      );

      sessionStorage.setItem(SESSION_STORE.PREPOLIZA, prepoliza);
    }
  }

  buildPago(): Pago {
    const medioDePago =
      this.formularioMedioDePago.value !== MedioDePago.PLACE_TO_PAY
        ? this.formularioMedioDePago.value
        : '';
    return new PagoBuilder()
      .withIdPago(this.pago.idPago)
      .withDescuentosAplicados(this.pago.descuentosAplicados)
      .withTotal(this.pago.total)
      .withSubTotal(this.pago.subTotal)
      .withTotalDescuentos(this.pago.totalDescuentos)
      .withMedioPagoSeleccionado(medioDePago)
      .build();
  }

  handlePushDatalayer(object: DatalayerEvent) {
    PushDatalayersGoogleTagManager.pushObject(object);
  }

  validateIdPago(idPago: string) {
    const pattern = new RegExp(CARACTERES_ESPECIALES_REGEX);

    if (!pattern.test(idPago)) {
      this.idPago = idPago;
      return;
    }

    // Es necesario agregar dicho timeout para que el error se muestre en el modal, debido a que el modal reacciona a la actualización del error seteado en el store.
    setTimeout(() => {
      this.pagoFacade.dispatch(
        idPagoInvalidFromUrl({ error: ERROR_IDPAGO_INVALIDO })
      );
    }, 500);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
